export default "__VITE_ASSET__Do4mi$Ht__"